import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginService } from './login/login.service';
@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private _loginService: LoginService, private _router: Router) {
  }

  canActivate() {
    const idSession: string = this._loginService.getToken();

    if (idSession) {
      return true;
    } else {
      this._router.navigate(['']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts